import moment, { now } from "moment-timezone";
import { convertToBinary, convertToNumber } from "./TimeSlotUtils";
import { TutorSchedule } from "../firestore/Types/TutorProfileSchema";

export function getTimeZoneOffset(timeZoneFrom: string, TimeZoneTo: string): number {
    const timeZoneOffset = moment.tz.zone(timeZoneFrom)?.utcOffset(now());
    const localOffset = moment.tz.zone(TimeZoneTo)?.utcOffset(now());
    if (timeZoneOffset === undefined || localOffset === undefined) {
        return 0;
    }
    return timeZoneOffset - localOffset;
}

export function getTutorScheduleLocalTime(tutorSchedule: TutorSchedule): TutorSchedule {
    var timeOffset = getTimeZoneOffset(tutorSchedule.TimeZone, moment.tz.guess());
    getTutorScheduleWithOffset(tutorSchedule, timeOffset);
    return tutorSchedule;
}

export function getTutorScheduleTutorTime(tutorSchedule: TutorSchedule): TutorSchedule {
    var timeOffset = getTimeZoneOffset(moment.tz.guess(), tutorSchedule.TimeZone);
    return getTutorScheduleWithOffset(tutorSchedule, timeOffset);
}

function getTutorScheduleWithOffset(tutorSchedule: TutorSchedule, offset: number) {
    var timeOffset = - offset / 30;
    if (timeOffset < 0) {
        timeOffset = 48 + timeOffset;
    }

    var combinedString = convertToBinary(tutorSchedule.Monday) 
        + convertToBinary(tutorSchedule.Tuesday) 
        + convertToBinary(tutorSchedule.Wednesday) 
        + convertToBinary(tutorSchedule.Thursday) 
        + convertToBinary(tutorSchedule.Friday) 
        + convertToBinary(tutorSchedule.Saturday) 
        + convertToBinary(tutorSchedule.Sunday);

    if (combinedString.length !== 336) {
        throw new Error("Invalid time slots");
    }

    var tempTimeSlot = combinedString + combinedString;
    const offsetTimeSlot = tempTimeSlot.slice(timeOffset, timeOffset + 336);
    var timeSlots: number[] = [];
    for (var i = 0; i < 7; i++) {
        var startIndex = i * 48;
        var endIndex = startIndex + 48;
        var timeSlot = offsetTimeSlot.slice(startIndex, endIndex);
        timeSlots.push(convertToNumber(timeSlot));
    }

    const localTimeTutorSchedule = {
        Monday: timeSlots[0],
        Tuesday: timeSlots[1],
        Wednesday: timeSlots[2],
        Thursday: timeSlots[3],
        Friday: timeSlots[4],
        Saturday: timeSlots[5],
        Sunday: timeSlots[6],
        TimeZone: tutorSchedule.TimeZone,
    } as TutorSchedule;

    return localTimeTutorSchedule;
}